class WorldBorder {
    constructor() {
        this.borderOffset = 5;
        this.distance = new THREE.Vector3();
    }

    limitToBorder(position) {
        throw new Error("subclass responsibility");
    }
}

export default WorldBorder;
